import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { Avatar, Box, Typography } from "@material-ui/core";
import { CustomCopyToClipboard } from "../../../../Components";
import { useTranslate } from "../../../../Hooks";

import useStyles from "./styles";

import { AEDIcon, CircleIcon } from "../../../../assets/icons";
import { formatNumberWithCommas } from "../../../../Helper";

function AgentCommissionCardSummary({ data }) {
  const styles = useStyles();
  const {
    agentName,
    propertyValue,
    totalAdminFees,
    totalAgencyFee,
    netAgencyFee,
    amountAfterAdminFees,
    totalDeduction,
    agentCommissionAfterDeduction,
    totalDealExpense,
    staffCode,
    agentCommission,
    finalNetAmount,
  } = data;
  const iconColorFill = ["#635235", "#A38F6F", "#667085"];

  const { translate } = useTranslate("AgentCommissionView");
  const { isDarkMode } = useSelector((state) => state.theme);

  return (
    <Box className={styles.mainContnet}>
      <Box className={styles.avatarContainer}>
        <Box>
          <Box className={styles.avatarWrapper}>
            <Avatar
              className={styles.defaultAvatar}
              src={"/images/contacts/MaleAvatar.svg"}
              alt={""}
              sizes="small"
            />
          </Box>
        </Box>
        <Box className={styles.userDetails}>
          <Typography className={styles.username}>{agentName}</Typography>
          {staffCode && (
            <CustomCopyToClipboard
              data={staffCode}
              childrenData={`#${staffCode}`}
            />
          )}
        </Box>
      </Box>
      <Box className={styles.contentWrapper}>
        <Box className={styles.list}>
          <Box className={styles.row}>
            <Box className={styles.col}>
              <CircleIcon fill={iconColorFill[0]} className={styles.icon} />
              <Typography className={styles.fieldTitle}>
                {translate("total-transaction")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={styles.fieldValue}
              >
                {`${formatNumberWithCommas(propertyValue)}`}
                <AEDIcon
                  width="14"
                  height="14"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#94969C" : "#7F6944"}
                />
              </Typography>
            </Box>
            <Box className={styles.col}>
              <CircleIcon fill={iconColorFill[1]} className={styles.icon} />
              <Typography className={styles.fieldTitle}>
                {translate("total-admin-fees")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={styles.fieldValue}
              >
                {`${formatNumberWithCommas(totalAdminFees)}`}
                <AEDIcon
                  width="14"
                  height="14"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#94969C" : "#7F6944"}
                />
              </Typography>
            </Box>
            <Box className={styles.col}>
              <CircleIcon fill={iconColorFill[2]} className={styles.icon} />
              <Typography className={styles.fieldTitle}>
                {translate("total-deal")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={styles.fieldValue}
              >
                {`${formatNumberWithCommas(totalDealExpense)}`}
                <AEDIcon
                  width="14"
                  height="14"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#94969C" : "#7F6944"}
                />
              </Typography>
            </Box>
          </Box>
          <Box className={styles.row}>
            <Box className={styles.col}>
              <CircleIcon fill={iconColorFill[0]} className={styles.icon} />
              <Typography className={styles.fieldTitle}>
                {translate("agent-commission")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={styles.fieldValue}
              >
                {`${formatNumberWithCommas(agentCommission)}`}
                <AEDIcon
                  width="14"
                  height="14"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#94969C" : "#7F6944"}
                />
              </Typography>
            </Box>
            <Box className={styles.col}>
              <CircleIcon fill={iconColorFill[1]} className={styles.icon} />
              <Typography className={styles.fieldTitle}>
                {translate("commission")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={styles.fieldValue}
              >
                {`${formatNumberWithCommas(agentCommissionAfterDeduction)}`}
                <AEDIcon
                  width="14"
                  height="14"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#94969C" : "#7F6944"}
                />
              </Typography>
            </Box>
            <Box className={styles.col}>
              <CircleIcon fill={iconColorFill[2]} className={styles.icon} />
              <Typography className={styles.fieldTitle}>
                {translate("total-deduction")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={clsx(styles.feesValue, styles.deduction)}
              >
                {totalDeduction === 0
                  ? `${formatNumberWithCommas(totalDeduction)}`
                  : `-${formatNumberWithCommas(totalDeduction)}`}
                <AEDIcon
                  width="14"
                  height="14"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#F97066" : "#D92D20"}
                />
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className={styles.wrapper}>
          <Box>
            <Box>
              <Typography className={styles.feesTitle}>
                {translate("agency-fee")}
              </Typography>
              <Typography
                style={{ display: "flex", alignItems: "center" }}
                className={styles.feesValue}
              >
                {`${formatNumberWithCommas(totalAgencyFee)}`}
                <AEDIcon
                  width="16"
                  height="16"
                  aspect-ratio="1/1"
                  fill={isDarkMode ? "#94969C" : "#7F6944"}
                />
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography className={styles.feesTitle}>
              {translate("net-agency-fee")}
            </Typography>
            <Typography
              style={{ display: "flex", alignItems: "center" }}
              className={styles.feesValue}
            >
              {`${formatNumberWithCommas(netAgencyFee)}`}
              <AEDIcon
                width="16"
                height="16"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#7F6944"}
              />
            </Typography>
          </Box>
          <Box>
            <Typography className={styles.feesTitle}>
              {translate("admin-fees-after")}
            </Typography>
            <Typography
              style={{ display: "flex", alignItems: "center" }}
              className={styles.feesValue}
            >
              {`${formatNumberWithCommas(amountAfterAdminFees)}`}
              <AEDIcon
                width="16"
                height="16"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#94969C" : "#7F6944"}
              />
            </Typography>
          </Box>
          <Box>
            <Typography className={styles.feesTitle}>
              {translate("final-net-amount")}
            </Typography>
            <Typography
              className={clsx(styles.feesValue, styles.finalNetAmount)}
            >
              {`${formatNumberWithCommas(finalNetAmount)}`}
              <AEDIcon
                width="18"
                height="18"
                aspect-ratio="1/1"
                fill={isDarkMode ? "#F5F5F6" : "#101828"}
              />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default AgentCommissionCardSummary;
